var FloatingMenu_module_default = {
	menu: "_menu_1kl3y_8",
	"slide-in": "_slide-in_1kl3y_1",
	"fade-in": "_fade-in_1kl3y_1",
	"fade-out": "_fade-out_1kl3y_1",
	title: "_title_1kl3y_65"
};
//#endregion
export { FloatingMenu_module_default as default };

//# sourceMappingURL=FloatingMenu.module.js.map